export default () => ({
  rapportages: [],
});
